import React, { ReactNode } from 'react';
import { getContext, isAnimationDisabled } from 'common';
import _merge from 'lodash/merge';
import ReactLoadingSkeleton, { SkeletonProps as ReactLoadingSkeletonProps } from 'react-loading-skeleton';
import TOKENS from '@nokia-csf-uxr/freeform-design-tokens';
import 'react-loading-skeleton/dist/skeleton.css';
import Styled from './styles';

export interface SkeletonProps extends ReactLoadingSkeletonProps {
  /** Forward props to the wrapping div. */
  wrapperProps?: any;
  /** To override the theme please refer to the `Readme` tab to learn more. */
  theme?: any;
  /** If true, disable all motion animation for this component.  This property will override any global disableAnimation setting. */
  disableAnimation?: boolean;
  /** Overlay an icon  -- you can pass in an Icon component here. */
  icon?: ReactNode;
}

/** Skeleton - loading placeholders that can take place of content before actual content loads.  Additional props are forwarded to `react-loading-skeleton` See:  https://github.com/dvtng/react-loading-skeleton for full documentation */
const Skeleton = React.forwardRef<HTMLElement, SkeletonProps>((props: SkeletonProps) =>
  getContext(({ RTL, theme, disableAnimation }) => {
    const { theme: themeProp, wrapperProps, disableAnimation: propsdisableAnimation, icon, ...otherProps } = props;
    const resolvedTheme = _merge({}, theme.SKELETON, themeProp);
    const resolvedDirection = RTL ? 'rtl' : 'ltr';
    return (
      <Styled.Skeleton $disableAnimation={isAnimationDisabled(propsdisableAnimation, disableAnimation)} {...wrapperProps}>
        <ReactLoadingSkeleton
          direction={resolvedDirection}
          baseColor={resolvedTheme.baseColor}
          highlightColor={resolvedTheme.highlightColor}
          borderRadius={TOKENS.RADIUS.RADIUS_2}
          {...otherProps}
        />
        {icon && <Styled.OverlayIcon>{icon}</Styled.OverlayIcon>}
      </Styled.Skeleton>
    );
  }));

Skeleton.displayName = 'Skeleton';
Skeleton.defaultProps = {
  theme: {},
  wrapperProps: undefined,
  disableAnimation: undefined,
  icon: undefined
};

/* Exports */
export { Skeleton as default };
